<template>
    <span>{{ label }}</span>
</template>

<script>
import ApiService from "../services/ApiService";

export default {
    name: "bonus-points",

    data()
    {
        return {
            points: null
        };
    },

    computed:
    {
        label()
        {
            if (this.points === null)
            {
                return "";
            }

            return this.points + " Punkte";
        }
    },

    mounted()
    {
        if (!this.$store.getters.isLoggedIn)
        {
            return;
        }

        ApiService.post("/bonus/points", {}, { supressNotifications: true, cache: false })
            .done((response) =>
            {
                const value = response && response.points;

                this.points = (value === null || typeof value === "undefined") ? 0 : value;
            })
            .fail(() =>
            {
                this.points = 0;
            });
    }
};
</script>
